import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=3cedac9e&scoped=true"
import script from "./ComparePage.vue?vue&type=script&lang=js"
export * from "./ComparePage.vue?vue&type=script&lang=js"
import style0 from "./ComparePage.vue?vue&type=style&index=0&id=3cedac9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cedac9e",
  null
  
)

export default component.exports